import Axios from 'axios'
import store from '../store'

const contact = {
  getFreeroomUrl(){
    return process.env.VUE_APP_URL_SERVER_BASE_FREEROOM
  },
  getClientIdFreeroom() {
    return store.getters['Client/clientIdFreeroom']
  },
  sendEmail (data) {
    return Axios.post(`${this.getFreeroomUrl()}/api/external/clients/${this.getClientIdFreeroom()}/contact`, data)
  },
  getContacts () {
    return Axios.get(`${this.getFreeroomUrl()}/api/internal/clients/${this.getClientIdFreeroom()}/contactAddress`)
  },
  saveContacts (contacts) {
    return Axios.put(`${this.getFreeroomUrl()}/api/internal/clients/${this.getClientIdFreeroom()}/contactAddress`, contacts)
  }
}

export default contact
